@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
	--jF-theme-color: #599bf8;
	--jF-theme-accent: #142f48;
	--jF-theme-h-text: #142F48;
	--jF-hover-color: #457ac4;
}

select {
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20fill='none'%20viewBox='0%200%2020%2020'%3E%3Cpath%20stroke='%236b7280'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='1.5'%20d='M6%208l4%204%204-4'/%3E%3C/svg%3E");
	background-position: right 0.5rem center;
	background-repeat: no-repeat;
	background-size: 1.5em 1.5em;
	padding-right: 2.5rem;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}

ul li,
ol li {
	list-style-type: inherit;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	font-size: inherit;
	font-weight: inherit;
	font-family: inherit;
}

p {
	font-size: inherit;
	font-family: inherit;
	font-weight: inherit;
}